var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaginationNext(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#D4D3E2",
    d: "M5.128.5C3.578.5 2.94.623 2.282.975c-.565.302-1.005.742-1.307 1.307C.623 2.941.5 3.578.5 5.128v23.744c0 1.55.123 2.187.475 2.846.302.565.742 1.005 1.307 1.307.659.352 1.296.475 2.846.475h23.744c1.55 0 2.187-.123 2.846-.475.565-.302 1.005-.742 1.307-1.307.352-.659.475-1.296.475-2.846V5.128c0-1.55-.123-2.187-.475-2.846-.302-.565-.742-1.005-1.307-1.307C31.059.623 30.422.5 28.872.5H5.128z",
    transform: "translate(-161 -6545) translate(40 6313) translate(0 138) translate(0 94) translate(121) matrix(-1 0 0 1 34 0)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#050D33",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M15.214 13.214L19.214 17.214 15.214 21.214",
    transform: "translate(-161 -6545) translate(40 6313) translate(0 138) translate(0 94) translate(121)"
  })))))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaginationNext);
export default __webpack_public_path__ + "static/media/pagination-next.aecee96f52becfd26bbe83b93d2a1cb1.svg";
export { ForwardRef as ReactComponent };